import { render, staticRenderFns } from "./AnnouncementPortlet.vue?vue&type=template&id=0f83bf51&"
import script from "./AnnouncementPortlet.vue?vue&type=script&lang=js&"
export * from "./AnnouncementPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports